// extracted by mini-css-extract-plugin
export default {"section":"styles_section__51w4v","icon":"styles_icon__gARHj","heading":"styles_heading__vDI8+","para":"styles_para__RtT6v"};